import { Button } from 'yoso';
import { t } from '~/components/I18n';
import { Alert, AlertProps, styles } from '~/components/Modal/Alert/Alert';

export const NftRequiredPopup = ({
  description = t('citizen_necessary_popup_desc1'),
}: AlertProps) => (
  <Alert
    title={t('citizen_necessary_popup_title')}
    description={description}
    confirmButton={
      <Button
        as="a"
        href={`${import.meta.env.VITE_CITIZEN_STORE_URL}/marketplace`}
        className={styles.confirmButton}
        data-event="click"
        data-event-taget="confirm_in_citizen_required_popup">
        {t('citizen_necessary_popup_button')}
      </Button>
    }
    // data-event="impression"
    // data-event-category="citizen_required_popup"
    // data-event-impression_id="{category}"
  />
);
